import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    container: {
      marginTop: 22,
      marginBottom: 8,
    },
    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
  });
